(function () {
  function pageScroller() {
    const canvas = document.querySelector('.ultimate-fullscreen-takeover-canvas');
    if (canvas && canvas.scrollHeight > canvas.clientHeight + 2) return canvas;
    return null;
  }

  function isFixedLeftChrome(node) {
    if (!node || !node.closest) return false;
    return !!node.closest(
      '.standalone-logo-menu-wrapper, .logo-menu-wrapper, .premium-product-info-left-align-panel, #leftInfoPanel'
    );
  }

  function usesTouchLogo() {
    try {
      if (window.matchMedia('(pointer: coarse)').matches) return true;
      if (window.matchMedia('(hover: none)').matches) return true;
    } catch (e) {}
    const ua = navigator.userAgent || '';
    return navigator.maxTouchPoints > 1 && /iPad|iPhone|iPod|Macintosh/.test(ua);
  }

  function isHome() {
    const path = window.location.pathname || '';
    return path === '/' || path === '';
  }

  function isPhoneLayout() {
    return window.innerWidth <= 749;
  }

  function goHome() {
    if (isHome()) return;
    window.location.assign('/');
  }

  function logoMenuWrapper() {
    return document.querySelector('.standalone-logo-menu-wrapper, .logo-menu-wrapper');
  }

  function closeAllLogoMenus() {
    document.querySelectorAll('.standalone-logo-menu-wrapper.is-active, .logo-menu-wrapper.is-active').forEach(function (wrapper) {
      wrapper.classList.remove('is-active');
    });
  }

  document.addEventListener(
    'wheel',
    function (event) {
      if (event.ctrlKey) return;
      if (window.innerWidth <= 989) return;
      const canvas = pageScroller();
      if (!canvas) return;

      const onLeftChrome = isFixedLeftChrome(event.target);
      const onLeftBand = event.clientX < 360 && !canvas.contains(event.target);
      if (!onLeftChrome && !onLeftBand) return;
      if (!onLeftChrome && canvas.contains(event.target)) return;

      canvas.scrollTop += event.deltaY;
      canvas.scrollLeft += event.deltaX;
      event.preventDefault();
    },
    { capture: true, passive: false }
  );

  document.addEventListener(
    'click',
    function (event) {
      const target = event.target;
      if (!target || !target.closest) return;

      const phoneLogo = target.closest('.mobile-center-logo-link');
      if (phoneLogo) {
        event.preventDefault();
        event.stopPropagation();
        goHome();
        return;
      }

      if (target.closest('.mobile-top-header-bar, .mobile-fullscreen-menu-overlay, .mobile-hamburger-trigger')) {
        return;
      }

      if (target.closest('a[href*="instagram.com"]')) return;

      if (isHome() && !isPhoneLayout()) {
        if (target.closest('.dropdown-links-panel')) return;
        const homeWrapper =
          (target.closest && target.closest('.standalone-logo-menu-wrapper, .logo-menu-wrapper')) ||
          logoMenuWrapper();
        if (!homeWrapper) return;
        event.preventDefault();
        event.stopPropagation();
        homeWrapper.classList.toggle('is-active');
        return;
      }

      const logo = target.closest('.corner-logo-btn-label');
      if (logo) {
        event.preventDefault();
        event.stopPropagation();
        const wrapper = logo.closest('.standalone-logo-menu-wrapper, .logo-menu-wrapper');
        if (usesTouchLogo() && wrapper) {
          if (wrapper.classList.contains('is-active')) {
            if (isHome()) {
              wrapper.classList.remove('is-active');
              return;
            }
            goHome();
            return;
          }
          closeAllLogoMenus();
          wrapper.classList.add('is-active');
          return;
        }
        goHome();
        return;
      }

      if (!usesTouchLogo()) return;
      if (target.closest('.dropdown-links-panel')) return;
      closeAllLogoMenus();
    },
    true
  );

  function bindLogoMenu(wrapper) {
    if (!wrapper || wrapper.dataset.logoMenuBound === 'true') return;
    wrapper.dataset.logoMenuBound = 'true';
    if (usesTouchLogo()) return;

    const logo = wrapper.querySelector('.corner-logo-btn-label, .corner-logo-img');
    const panel = wrapper.querySelector('.dropdown-links-panel');
    if (!logo) return;
    let closeTimer = null;
    function openMenu() {
      clearTimeout(closeTimer);
      wrapper.classList.add('is-active');
    }
    function scheduleClose() {
      clearTimeout(closeTimer);
      closeTimer = setTimeout(function () {
        wrapper.classList.remove('is-active');
      }, 120);
    }
    logo.addEventListener('mouseenter', openMenu);
    logo.addEventListener('mouseleave', scheduleClose);
    if (panel) {
      panel.addEventListener('mouseenter', openMenu);
      panel.addEventListener('mouseleave', scheduleClose);
    }
  }

  function bindLogoMenus() {
    document.querySelectorAll('.standalone-logo-menu-wrapper, .logo-menu-wrapper').forEach(bindLogoMenu);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bindLogoMenus);
  } else {
    bindLogoMenus();
  }
})();
